export const ROLE_PERMISSIONS = {
  SUPERADMIN: ['view', 'edit', 'delete', 'administer-locations', 'administer-countries', 'view-material-checks', 'create-material-checks'],
  ADMIN: ['view', 'edit', 'delete', 'view-material-checks', 'create-material-checks'],
  VIEWER: ['view', 'view-material-checks'],
  EMPLOYEE: ['create-material-checks'],
};
